import React, { useContext } from "react";
import { ProjectContext } from "../../context/project_context";

const ProjectTranscribeAudio = () => {
  const { project, updateProject, uploadSrtFile } = useContext(ProjectContext);

  const handleSkip = async () => {
    await updateProject({
      ...project,
      project_status: "identify_transcript_errors"
    });
  };

  const handleSrtUpload = async (event) => {
    const file = event.target.files[0];
    if (!file || !file.name.endsWith('.srt')) {
      alert('Please select a valid SRT file');
      return;
    }

    const formData = new FormData();
    formData.append('srt_file', file);
    formData.append('project_id', project.id);

    try {
      await uploadSrtFile(formData);
    } catch (error) {
      alert('Failed to upload SRT file');
    }
  };

  return (
    <div className="project-transcribe-audio">
      <h2>Transcribe Audio</h2>
      <div className="transcribe-content">
        <p>Project Name: {project.name}</p>
        
        <div className="mt-3">
          <label htmlFor="srtFile" className="form-label">Upload SRT File</label>
          <input
            type="file"
            className="form-control"
            id="srtFile"
            accept=".srt"
            onChange={handleSrtUpload}
          />
        </div>

        <button 
          className="btn btn-secondary mt-3"
          onClick={handleSkip}
        >
          Skip Transcription
        </button>
      </div>
    </div>
  );
};

export default ProjectTranscribeAudio; 